import { render, staticRenderFns } from "./ExternalDeliveryTargetsModal.vue?vue&type=template&id=4af6e99b&scoped=true&"
import script from "./ExternalDeliveryTargetsModal.vue?vue&type=script&lang=js&"
export * from "./ExternalDeliveryTargetsModal.vue?vue&type=script&lang=js&"
import style0 from "./ExternalDeliveryTargetsModal.vue?vue&type=style&index=0&id=4af6e99b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6e99b",
  null
  
)

export default component.exports